<template>
    <div>
        <div class="container-fluid info-viewer"
            v-if="isVisible"
            :style="{
                position: 'fixed', 
                top: 0, 
                left:0,
                height: '100vh',
                width: '100vw'
            }">
            <div>
                <!-- <div class="row m-3"
                :style="{ 
                    position: 'fixed',
                    left: '100px',
                    bottom: 130*scale[1] + 'px',
                    height: '185px',
                    width: '450px'
                    }"
                >    -->
                    <!-- <div class="col align-self-end float-right"
                        :style="{ 
                                width: '143px',
                                height: '140px'
                            }"
                        >
                        <img
                            :src="galleryTextSquiggle"
                            class="img-fluid float-right align-self-end"
                            :style="{ 
                                cursor: 'url(' + clickCursor + '), pointer',
                                width: '143px',
                                height: '140px'
                            }"
                        >
                    </div> -->
                    <!-- <div class="col align-self-end float-right">
                        <svg 
                            width="145" 
                            height="142" 
                            viewBox="0 0 145 142" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg">
                            <path class="path2" 
                                d="M1 141C27 51.5 83.5 3 113 78.5C110.667 56.1667 113.6 9.4 144 1" 
                                stroke="white" 
                                stroke-width="1.5"/>
                        </svg>
                    </div>
                    <div class="col justify-content-left align-items-start mt-0">
                        <h2 class="text-left align-items-start mt-0" style="font-size: 24px;">Hover to read gallery text</h2>
                    </div>
                </div> -->
                <div class="row justify-content-end"
                    :style="{ 
                        position: 'fixed',
                        width: '500px',
                        right: '100px',
                        bottom: (150.0/1600)*this.screenScale[1] + 'px',
                        height: '153px'
                        }"
                    >   
                    <div class="col justify-content-end align-items-start mt-0">
                        <h2 class="text-right align-items-start mt-0" style="font-size: 24px;">Click to view labels & click labels for details</h2>
                    </div>
                    <!-- <div class="col align-self-end float-left"
                        :style="{ 
                                width: '192px',
                                height: '110px'
                            }"
                    >
                        <img
                            :src="eyeSquiggle"
                            class="img-fluid float-left align-self-end animate-svg"
                            :style="{ 
                                cursor: 'url(' + clickCursor + '), pointer',
                                width: '192px',
                                height: '110px'
                            }"
                        >
                    </div> -->
                    <div class="col align-self-end float-left">
                        <svg 
                            :width="192"
                            :height="113" 
                            viewBox='0 0 192 113'
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg">
                            <path 
                                class="path" 
                                d="M1.5 27.9999C39 -22.0001 84.5 0.999855 88.5 82.4999C91.3333 66.3332 105.592 34.963 123 27.9999C135.5 22.9999 166 25.4999 193 112" 
                                stroke="white" 
                                stroke-width="1.5"
                                />
                        </svg>
                    </div>
                    
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
export default {
  name: "Info",
  props: ["imgSize", "isVisible"],
  components: {
  },
  data: function() {
      return {
          scale: [1, 1],
          windowW: window.innerWidth,
          screenScale: [1, 1],
          clickCursor: require('@/assets/cursors/pointer.svg'),
          imgRescaledSize: [],
          galleryTextSquiggle: require('@/assets/icons/galleryTextSquiggle.svg'),
          eyeSquiggle: require('@/assets/icons/eyeSquiggle.svg'),
      };
  },
  computed: {
  },
  methods: {
      setScaling() {
        let imgSizeRatio = (this.imgSize[0]/this.imgSize[1]);
        let screenRatio = window.innerWidth/window.innerHeight;
        let modHeight = this.imgSize[1] * (window.innerWidth/this.imgSize[0]);
        let modWidth = this.imgSize[0] * (window.innerHeight/this.imgSize[1]);
        let height = ((screenRatio > imgSizeRatio) ? modHeight : window.innerHeight);
        let width = ((screenRatio > imgSizeRatio) ? window.innerWidth : modWidth);
        this.scale = [width/this.imgSize[0], height/this.imgSize[1]];
        this.screenScale = [window.innerWidth, window.innerHeight];
        this.imgRescaledSize = [width, height];
        this.windowW = window.innerWidth;
      },
    checkImageProportions(img) {
        if (img.width > img.height) {
            return true;
        }
        return false;
    },
  },
  created() {
    this.setScaling();
    window.addEventListener("resize", this.setScaling);
  },
  destroyed() {
      window.removeEventListener("resize", this.setScaling);
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
    margin: 40px 0 0;
    /* font-family: 'GTF Riposte TRIAL'; */
    font-family: 'Inter Tight', sans-serif;
    font-weight: 100;
}

.item-title {
    /* font-family: 'GTF Figue TRIAL'; */
    font-family: 'Playfair Display', serif;
    font-size: 1.2rem;
    color:white;
    text-align: left;
}

.container-fluid {
    cursor: 'url("../assets/cursors/pointer.svg"), auto';
}

.path {
  stroke-dasharray: 400;
  stroke-dashoffset: 400;
  animation: dash 1.5s ease-in-out forwards;
}

.path2 {
  stroke-dasharray: 400;
  stroke-dashoffset: -400;
  animation: dash 1.5s ease-in-out forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

.lightbox {
    z-index:12;
}

.overlay {
  background-color: black;
  opacity: 0.6;
  z-index: 2;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0s;
}
.fade-enter-to {
  opacity: 0.6;
}
.fade-leave {
  opacity: 0.6;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-leave-to {
  opacity: 0;
}

.info-viewer {
    z-index: 30;
}
</style>

